module.exports = __webpack_public_path__ + "img/ug422.24aaf6d6.png";